.backdrop {
  position: fixed;
  inset: 0;
  z-index: 20;
  background: rgb(16 18 24 / 45%);
  opacity: 0;
  /* Пока закрыта — не перехватывает нажатия и не видна для чтения с экрана. */
  visibility: hidden;
  transition: opacity 0.22s ease, visibility 0.22s;
  /* Прокрутка страницы под шторкой не должна тянуться от подложки. */
  touch-action: none;
}

.sheet {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 21;
  display: flex;
  flex-direction: column;
  /* Примерно половина экрана: видно около десяти строк, и при этом
     остаётся понятно, что за шторкой прежний экран. */
  height: 58vh;
  background: var(--bg);
  border-radius: var(--r-xl) var(--r-xl) 0 0;
  box-shadow: 0 -12px 40px rgb(20 22 28 / 18%);
  transform: translateY(100%);
  visibility: hidden;
  transition: transform 0.26s cubic-bezier(0.2, 0.8, 0.2, 1), visibility 0.26s;
}

.fit {
  height: auto;
  max-height: 88vh;
}

.open {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.grabber {
  flex: 0 0 auto;
  width: 38px;
  height: 4px;
  margin: 10px auto 2px;
  background: var(--line);
  border-radius: 2px;
}

.head {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px var(--pad) 12px;
}

.title {
  font-size: 17px;
  font-weight: 600;
}

.close {
  padding: 6px 10px;
  font-size: 14px;
  color: var(--accent-ink);
  background: none;
  border: 0;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.body {
  flex: 1 1 auto;
  padding: 0 var(--pad) calc(20px + var(--tg-viewport-safe-area-inset-bottom, 0px));
  overflow-y: auto;
  /* Прокрутка не передаётся странице под шторкой. */
  overscroll-behavior: contain;
}

@media (prefers-reduced-motion: reduce) {
  .backdrop,
  .sheet {
    transition: none;
  }
}

@media (min-width: 640px) {
  .sheet {
    right: calc(50% - var(--column) / 2);
    left: calc(50% - var(--column) / 2);
  }
}
